/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EMBED ORGANIZE : MOVE LIVE CONTENT : STYLES --------------- ++++++++++ */
export default theme => ({
    movelivecontent: {
        marginBottom: pxToEm(20),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .field': {
            maxWidth: pxToEm(85),
            paddingRight: pxToEm(10),
            '& .formelement': {
                height: pxToEm(32)
            }
        },
        '& button': {
            width: pxToEm(85),
            height: pxToEm(32)
        }

    }
});
